export const XbyYPairs = ['ETH/SOL', 'SOL/ETH']
